export default {
  common: {
    requests: 'барања',
    request: 'Побарај',
    signUp: 'Пријавете се',
    logOut: 'Одјавете се',
    seeAll: 'Видете сè',
    follow: 'Следете',
    unfollow: 'Престанете да следите',
    email: 'Е-пошта',
    fullName: 'Целосно име',
    password: 'Лозинка',
    next: 'Следно',
    addNew: 'Додадете ново',
    type: 'Тип',
    typeYourMessage: 'Напишете ја вашата порака',
    yourMessage: 'Вашата порака',
    message: 'Пишете порака',
    shoutOut: 'Пофалете',
    story: 'Приказна',
    chat: 'Разговор',
    featureComingSoon: 'Оваа опција ќе биде достапна наскоро!',
    okay: 'Okay',
    send: 'Испрати',
    delete: 'Избришете',
    cancel: 'Прекини',
    search: 'Пребарувајте',
    back: 'Назад',
    goToHome: 'Одете дома',
    addShoutout: 'Додајте пофалба',
    player: 'Играч',
    text: 'Текст',
    video: 'Видео',
    comment: 'Коментирајте',
    team: 'Тим',
    country: 'Држава',
    city: 'Град',
    userName: 'Корисничко име',
    following: 'Следите',
    followers: 'Следбеници',
    referals: 'Препораки',
    athletes: 'Спортисти',
    shoutouts: 'Пофалби',
    showMore: 'Прикажете повеќе',
    showLess: 'Прикажете помалку',
    sport: 'Спорт',
    position: 'Позиција',
    league: 'Лига',
    info: 'Инфо',
    repost: 'Објавете',
    share: 'Споделете',
    confirmed: 'Потврдено',
    refused: 'Одбиено',
    pending: 'Oбработка',
    canceled: 'Откажано',
    trending: 'Актуелно',
    latest: 'Најново',
    noData: 'Нема податоци',
    from: 'од',
    to: 'За',
    settings: 'Поставки',
    areYouSure: 'Дали сте сигурни',
    profile: 'Профил',
    accept: 'Прифатете',
    refuse: 'Одбијте ги сите',
    missing: 'Недостасува',
    select: 'Изберете',
    currency: 'Валута',
    zipCode: 'Поштенски број',
    goBack: 'Вратете се назад',
    done: 'Завршено',
    remove: 'Отстранете',
    date: 'Датум',
    description: 'Опис',
    amount: 'Износ',
    upload: 'Поставете',
    getApp: 'Преземете ја апликацијата',
    today: 'Денес',
    yesterday: 'Вчера',
    tomorrow: 'Утре',
    confirm: 'Потврди',
    confirmAll: 'Потврдете ги сите',
    login: 'Логирајте се',
    ad: 'Реклама',
    aboutUs: 'За нас',
    fan: 'Обожавател',
    athlete: 'Спортист',
    stats: 'Статистики',
    posts: 'Објави',
    store: 'Продавница',
    or: 'Или',
    shoutout: 'Пофалете',
    proceed: 'Продолжете',
    required: 'Се бара',
    dismiss: 'Затворете',
    save: 'Зачувај',
    discard: 'Отфрлете',
    submit: 'Поднесете',
    live: 'Во живо',
    openInbox: 'Отворете сандаче',
    home: 'Дома',
    searchDotDotDot: 'Барајте...',
    reply: 'Одговорете',
    subscribers: 'Претплатници',
    subscribed: 'Претплатени',
    subscribe: 'Претплатете се',
    unsubscribe: 'Откажете се од претплатата',
    fans: 'Обожаватели',
    teams: 'Тимови',
    setup: 'Поставување',
    feed: 'Времеплов',
    messages: 'Пораки',
    earlier: 'Претходно',
    apply: 'Пријавете се',
    oneOnOnes: 'Еден-на-еден',
    sort: 'Подредете',
    comingSoon: 'Наскоро',
    goLive: 'Одете во живо',
    total: 'Вкупно',
    pay: 'Плати {{amount}}',
    free: 'бесплатно',
    location: 'Локација',
    countries: 'Држави',
    more: 'повеќе',
    less: 'помалку',
    block: 'Блокирајте',
    unblock: 'Одблокирајте',
    privacyPolicy: 'Политика за приватност',
    termsAndConditions: 'Правила и услови',
    createNew: 'Создадете ново',
    game: 'Игра',
    unlock: 'Отклучете',
    post: 'Објавете',
    uploadFile: 'Поставете датотека',
    checkIn: 'Пријавете се',
    unregisteredType: 'Ова не се бара',
    required: 'Се бара',
    create: 'Create',
    reply: 'Reply'
  },
  sports: {
    americanFootball: 'Американски фудбал',
    baseball: 'Бејзбол',
    basketball: 'Кошарка',
    boxing: 'Бокс',
    cricket: 'Крикет',
    soccer: 'Фудбал',
    mma: 'ММА',
    race: 'Тркање со автомобил',
    tennis: 'Тенис',
    carRace: 'Тркање со автомобил',
    acrobatics: 'Акробатика',
    airSports: 'Воздушни спортови',
    archery: 'Стрелаштво',
    combatSports: 'Борбени спортови',
    cycling: 'Велосипедизам',
    cueSports: 'Билјард',
    equestrianSports: 'Коњички спортови',
    golf: 'Голф',
    handball: 'Ракомет',
    iceSports: 'Спортови на мраз',
    lacrosse: 'Лакрос',
    polo: 'Поло',
    weightlifting: 'Кревање тежина',
    rowing: 'Веслање',
    softball: 'Софтбол',
    rugby: 'Рагби',
    volleyball: 'Одбојка',
    coachingMentoring: 'Тренирање и менторство',
    figureSkating: 'Уметничко лизгање',
    formula1: 'Формула-1',
    gymnastics: 'Гимнастика',
    hockey: 'Хокеј',
    kickboxing: 'Кик-бокс',
    motorSports: 'Спортови со мотор',
    muayThai: 'Тајландски бокс',
    olympics: 'Олимпијада',
    poleSports: 'Пол спортс',
    sportsInfluencer: 'Спортски инфлуенсер',
    swimming: 'Пливање',
    trackField: 'Атлетика',
    visualArtist: 'Визуелен уметник',
    wheelchairRugby: 'Рагби со инвалидска количка',
    wrestling: 'Борење',
    iceHockey: 'Хокеј на мраз',
    alpineSkiing: 'Алпско скијање',
    flagFootball: 'Фудбал со Знаме',
    climbing: 'Планинарење',
    badminton: 'Бадминтон',
    motorcycleRacing: 'Трки со мотоцикл'
  },
  levels: {
    interested: 'Заинтересиран',
    beginner: 'Почетник',
    amateur: 'Аматер',
    intermediate: 'Среден',
    expert: 'Експерт',
    retired: 'Во пензија'
  },
  auth: {
    signUpFacebook: 'Пријавете се со Фејсбук',
    signUpGoogle: 'Пријавете се со Google',
    signUpPaypal: 'Пријавете се со PayPal',
    forgottenPassword: 'Ја заборавивте лозинката?',
    logInFacebook: 'Најавете се со Фејсбук',
    logInGoogle: 'Најавете се со Google',
    logInPaypal: 'Најавете се со PayPal',
    dontHaveAccount: 'Немате сметка?',
    mustContain8Characters: 'Мора да содржи најмалку 8 знаци.',
    alreadyHaveAccount: 'Веќе имате профил?',
    passwordReset: 'Ресетирање на лозинката',
    resetInstructions:
      'Внесете ја е-поштата поврзана со вашата сметка и ние ќе ви ги испратиме упатствата за враќање на лозинката.',
    sendRecoveryEmail: 'Испратете е-пошта за губитокот на лозинката',
    backTo: 'Назад кон',
    logIn: 'Логирате се',
    checkEmail: 'Проверете ја вашата адреса за е-пошта',
    noAccount: 'Нема поврзана сметка',
    pleaseTryAnother: 'Ве молиме обидете се со друга адреса.',
    tryAnother: 'Обидете се со друга е-пошта',
    emailSent: 'Испратена е-пошта за губитокот на лозинката',
    checkEmailInstructions:
      'Проверете го вашето сандаче (и папките за спам) за да ги најдете и следете упатствата за ресетирање на лозинката.',
    createNewPassword: 'Направете нова лозинка',
    newPassword: 'Нова лозинка',
    confirmPassword: 'Потврдете ја лозинката',
    resetPassword: 'Ресетирајте ја лозинката',
    validateYourEmail: 'Потврдете ја вашата е-пошта',
    validateEmailInstructions:
      'Треба да ја потврдите вашата е-пошта со активирање на вашата нова сметка на P4P.',
    confirmEmail: 'Потврдете ја е-поштата',
    validationEmailSent: 'Испратена е-пошта за валидација',
    checkInboxToValidateEmail:
      'Проверете го вашето сандаче (и папките за спам) за да ги најдете и следете инструкциите за потврдување на вашата е-пошта.',
    getTheApp: 'Симнете ја апликацијата',
    accountLocked: 'Вашата сметка е заклучена',
    accountLockedDesc:
      'Ги чуваме нештата безбедни и ја заклучивме вашата сметка поради премногу обиди со погрешни податоци. Проверете го вашето сандаче за да ја ресетирате лозинката.',
    checkInbox: 'Проверете го сандачето',
    youAcceptTerms:
      'Со регистрирање или најавување, се согласувате со нашите Услови и правила и Политика за приватност',
    logInApple: 'Најавете се со Apple',
    signUpApple: 'Пријавете се со Apple'
  },
  messages: {
    newMessages: 'Нови пораки',
    newGroup: 'Нова група',
    favorites: 'Омилени',
    favoritesAtTop: 'Омилени на врвот',
    favoritesOnly: 'Само омилените',
    excludeHidden: 'Исклучи ги скриените',
    showHidden: 'Прикажи ги скриените',
    hiddenChats: 'Скриени разговори',
    message: 'Порака',
    addChat: 'Додадете разговор',
    searchFriends: 'Барајте пријатели',
    createdGroup: '{{group}} ја создаде оваа група',
    totalMessageSingular: '1 Нова порака',
    totalMessages: '{{totalMessageCount}} Нови пораки',
    noChats: 'Нема достапни разговори.',
    noChatSelected: 'Не е избран разговор.',
    messageDotDotDot: 'Порака...',
    noChatYet: 'Сè уште нема разговор овде...',
    searchFriendsGroups: 'Пребарувајте пријатели или групи...',
    selectFriend: 'Изберете пријател',
    groupChatName: 'Име на групен разговор',
    startChat: 'Започнете разговор',
    youNeedSub: 'Треба да се претплатите на {{name}} за да испратите порака',
    youBlocked: 'Го блокиравте овој корисник'
  },
  home: {
    latestPosts: 'Најнови објави',
    confirmed: 'Потврдено',
    playazRunsSafeEnvironment: 'Playaz води безбедна средина',
    connectionsConverstationsFollowedAthletes:
      'Врски со истомисленици за да имате разговори, групни состаноци и лекции од спортистите кои ги следите.',
    myPosts: 'Моите објави',
    accountsToFollow: 'Профили за следење',
    comingUp: 'Наскоро',
    gloriousWinners: 'Славни победници',
    todaysGames: 'Денешни игри',
    athleteHighlights: 'Важни моменти од спортисти',
    fanHighlights: 'Важни моменти од обожаватели',
    todaysMatches: 'Денешни натпревари'
  },
  add: {
    followers: 'Следбеници',
    subscribers: 'Претплатници',
    onlyMe: 'Само јас',
    photoVideo: 'фотографии/видеа',
    tag: 'Тагирај',
    editMedia: 'Уредете',
    tapCrop: 'Допрете на слика за отсекување.',
    gallery: 'Галерија',
    addMultiple: 'Додадете повеќе',
    shoutOutTo: 'Пофалба за',
    whereItHappens: 'Центарот на случувањата',
    shouldAcceptTerms: 'Треба да ги прифатите Условите и правилата',
    summary: 'Резиме',
    total: 'Вкупно',
    iAcceptTerms:
      'Според одредбите и условите, прифаќам да ми се наплати износот наведен погоре по потврдата од спортистот',
    post: 'Објавете',
    enterYoutubeLink: 'Внесете линк од YouTube',
    tagFriends: 'Означете пријатели',
    shareWith: 'Споделете со',
    everyone: 'Сите',
    peopleFollowBack: 'Само луѓе кои ги следам',
    linkToVideo: 'Линк до видеото',
    swipeRightPurchase: 'Повлечете надесно за да купите',
    uploadMedia: 'Поставете',
    shareLink: 'Споделете го линкот',
    correctYoutubeLink: 'Додадете точен линк од YouTube.',
    writeCaption: 'Напишете објаснување',
    selectionsWillRemove:
      'Може да објавите само едно видео, другите селекции ќе бидат отстранети. Продолжете?',
    selectVideo: 'Изберете видео',
    onlySingleVideo: 'Засега можете да објавите само едно видео.',
    upToAMinutes: 'Дозволена е максимална должина на видео од 1 минута.',
    text: 'Текст',
    video: 'Видео',
    tagPeople: 'Означете луѓе',
    enterLink: 'Внесете линк',
    linkToOriginalPost: 'Линк до оригиналната објава',
    pasteForPreview: 'Залепете го линкот за да го видите прегледот на објавата',
    createPost: 'Креирајте објава...',
    recent: 'Неодамнешни',
    noUserFound: 'Не се најдени корисници со наведените критериуми',
    searchResults: 'Резултати од пребарувањето',
    storyPublished: 'Приказната е објавена!',
    live: 'Во живо',
    shoutout: 'Пофалба',
    addPhotosAndVideos: 'Додајте фотографии и видеа',
    addLocation: 'Додадете локација',
    onlyForSubscribers: 'Само за претплатници',
    photosAndVideos: 'Фотографии и видеа',
    selectUpTo10: 'Изберете до 10',
    suggested: 'Предложено',
    shoutoutTo: 'Пофалба до',
    createShoutout: 'Креирајте пофалба',
    newShoutout: 'Нова пофалба',
    tapOrHold: 'Допрете за фотографија, држете за видео',
    tapGoLive: 'Допрете за да одите во живо',
    addNewPost: 'Додадете нова објава',
    addNewShoutout: 'Додадете нова пофалба',
    fileFormats: 'Формати на датотеки JPEG, PNG, MP4, WebM или Ogg',
    create: 'Креирајте',
    correctLink: 'Ве молиме додадете точен линк.',
    teamOrPlayer: 'Тим или единичен играч',
    createNewShoutout: 'Напиши ново признание',
    createNewPost: 'Направи нова објава'
  },
  browse: {
    trySearchAthlete: 'Обидете се да барате спортист, тим или хаштаг',
    basedYourPreferences:
      'Врз основа на вашите преференции, еве неколку спортисти и обожаватели што може да ги следите.',
    erlingHaaland: 'Ерлинг Халанд',
    parisSaintGermain: 'Пари Сен Жермен',
    trendingPosts: 'Актуелни објави',
    chooseSportAndFavoriteTeam:
      'Изберете спорт и изберете го вашиот омилен тим на спортисти за да ве информираме.',
    trendingTeams: 'Актуелни тимови',
    seeTeamsYourFellow: 'Погледнете ги тимовите што ги следат другите навивачи и спортисти.',
    atalanta: 'Аталанта',
    serieaFootballClub: 'Серија А фудбалски клуб',
    browse: 'Прелистајте',
    athletesOnPlatform: 'Спортисти на P4P',
    fansOnPlatform: 'Обожаватели на P4P',
    upcomingEvents: 'Претстојни настани',
    eventsComingUpYourFavorite:
      'Претстојни настани за вашите омилени спортови, тимови и спортисти.',
    superBantamweight: 'Супер Бантамвејт',
    tiffanyVanSoestAlinePereira: 'Тифани Ван Соест',
    chicagoVenue: 'Чикаго, Место на одржување во Чикаго',
    suggestedAthletes: 'Препорачани спортисти',
    suggestedFans: 'Предлог обожаватели',
    suggestedAccounts: 'Предложени профили',
    newAppHasArrived: 'Нашата нова апликација пристигна!',
    newAppDesc:
      'Го збогативме вашето P4P искуство со вашите повратни информации. Уживајте во ажурираната апликација и останете во тек за дополнителни ажурирања.',
    seeTheApp: 'Видете ја апликацијата',
    postCountSingular: '1 објава',
    postCountPlural: '{{count}} објави',
    recent: 'Неодамнешни',
    top: 'Врвот',
    athletes: 'Спортисти',
    teams: 'Тимови',
    tags: 'Тагови',
    fans: 'Обожаватели',
    trendingShoutouts: 'Актуелни пофалби',
    goBrowse: 'Прелистајте',
    follower: 'следбеник',
    followers: 'следбеници',
    todaysGames: 'Денешни игри',
    trendingAthletes: 'Актуелни спортисти',
    trendingFans: 'Актуелниобожаватели',
    allAthletes: 'Сите спортисти',
    allFans: 'Сите фанови',
    sortBy: 'Сортирајте по',
    name: 'Име',
    popularity: 'Популарност',
    recentlyRegistered: 'Неодамна регистриран',
    filterByConnection: 'Филтрирајте по поврзување',
    showAll: 'Прикажете се',
    showOnlyConnect: 'Покажете ги само спортистите со коишто можете да се поврзете',
    teamsOnPlatform: 'Тимови на P4P',
    allTeams: 'Сите тимови',
    todaysMatches: 'Денешни натпревари'
  },
  chat: {
    muteNotifications: 'Исклучете го звукот на известувањата',
    removeFavorites: 'Отстранете од омилените',
    addFavorites: 'Додадете во омилените',
    clearChatHistory: 'Исчистете ја историјата на разговорот',
    youCannotAction: 'Не можете да ја вратите оваа постапка.',
    deleteConversationWith: 'Избришете го разговорот со',
    deleteConversation: 'Избришете го разговорот',
    unhideChat: 'Откријте го разговорот',
    hideChat: 'Сокријте разговорот',
    clearHistory: 'Исчистете ја историјата',
    noResults: 'Нема резултати...',
    noMessagesYet: 'Сè уште нема пораки овде...',
    returnChat: 'Вратете се на разговорот',
    searchMessages: 'Барајте пораки...',
    clearConfirmation: 'Дали сте сигурни дека сакате да го исчистите овој разговор?',
    deleteConfirmation: 'Дали сте сигурни дека сакате да го избришете овој разговор?',
    block: 'Блокирајте',
    disableSound: 'Оневозможете звук',
    muteNotificationsFor: 'Исклучете го звукот на известувањата за...',
    thirtyMinutes: '30 минути',
    oneHour: '1 час',
    oneDay: '1 ден',
    oneWeek: '1 недела',
    oneMonth: '1 месец',
    muteForever: 'Исклучете засекогаш'
  },
  comments: {
    succesfullyReactedPost: 'Успешно реагиравте на оваа објава.',
    beFirstReaction: 'Бидете првата реакција',
    comments: 'Коментари',
    noComments: 'Нема коментари',
    comment: 'Коментирајте'
  },
  connect: {
    endOneOnOneWith: 'Завршете еден-на-еден со',
    youWontGoBackCall: 'Нема да може да се вратите на овој платен повик.',
    sayGoodBye: 'Збогувајте се со ',
    timeToWrapUp: 'Време е да завршете',
    oneOnOneCall: 'Повик еден-на-еден',
    setupConnect: 'Поставете поврзување еден-на-еден'
  },
  connectConfirmations: {
    cancelOneOnOne: 'Откажете еден-на-еден',
    unfortunatelyCanceled: 'За жал, вашето поврзување еден-на-еден со {{name}} е откажано.',
    timeToStart: 'Време е да ги започнете вашите резервирани 15 минути еден-на-еден со {{name}}',
    swipeCancel: 'Повлечете надесно за да го откажете поврзувањето',
    wantCancelOneOnOne: 'Дали сакате да го откажете ова еден-на-еден поврзување ',
    youWillPay: 'Ова не може да се врати и ќе платите такса за откажување ( {{amount}} )',
    fanWillGet: 'Ова не може да се врати и обожаватelot ќе добиe 100% рефундирање ( {{amount}} )',
    swipeRightStart: 'Повлечете надесно за да започнете да се поврзувате',
    oneOnOneConnectEnded: 'Поврзувањето еден-на-еден заврши',
    '15minCall':
      'Вашиот 15-минутен повик со {{name}} и се надеваме дека сте имале возбудлив разговор со вашиот омилен спортист.',
    bookAnotherOneOnOne: 'Резервирајте дополниителен еден-на-еден',
    refuseOneOnOne: 'Одбијте еден-на-еден',
    wantRefuseOneOnOne: 'Дали сакате да одбиете еден-на-еден со {{name}}',
    swipeRightRefuseConnect: 'Повлечете надесно за да одбиете поврзување',
    '15minCallWithAthlete':
      'Вашиот 15-минутен повик со {{name}} и се надеваме дека сте имале возбудлив разговор со вашиот омилен спортист.',
    waitingInLobby: 'Се чека во фоајето...',
    pleaseWaitUser:
      'Ве молиме почекајте да започне вашиот еден-на-еден со <strong> {{name}} <\/strong> .',
    refusedOneOnOneConnect: 'Одбиено поврзување еден-на-еден',
    callSettings: 'Поставки за повици:'
  },
  settings: {
    referAnAthlete: 'Препорачајте спортист',
    upgradePlan: 'Надградете го планот',
    settings: 'Поставки',
    changePassword: 'Променете го пасвордот',
    oldPassword: 'Стара лозинка',
    newPassword: 'Нова лозинка',
    privacyAndSecurity: 'Приватност и безбедност',
    profilePrivacySettings: 'Поставки за приватност на профилот',
    whoCanView: 'Кој може да ја прегледа страницата на вашиот профил?',
    whoCanViewInfo: 'Кој може да ја види картичката за информации на страницата на вашиот профил?',
    whoCanViewBasicInfo: 'Кој може да ги види вашите основни информации?',
    whoCanViewLocation: 'Кој може да ја види вашата локација?',
    whoCanViewActivities:
      'Кој може да го гледа делот за вашите активности на страницата на вашиот профил?',
    whoCanShare: 'Кој може да сподели објава на вашиот ѕид?',
    whoCanViewFriends: 'Кој може да ја види листата на вашите пријатели?',
    whoCanSendFriends: 'Кој може да ми испрати барање за пријателство?',
    whoCanSendMessage: 'Кој може да ви испрати порака?',
    whoCanViewPhotos: 'Кој може да гледа фотографии на страницата на вашиот профил?',
    whoCanPokes: 'Кој може да боцка?',
    whoCanViewViewed: 'Кој може да види кој неодамна го гледал вашиот профил?',
    whoCanTag: 'Кој може да ме означи?',
    whoCanSeeDateOfBirth: 'Кој може да го види вашиот датум на раѓање?',
    allowSharing: 'Дозволете споделување од',
    allowMentions: 'Дозволете споменувања од',
    allowTags: 'Дозволете ознаки од',
    avilabilityPeriod: 'Период на достапност',
    pleaseShare:
      'Ве молиме споделете ги вашите месечни очекувања за приходи. Обожавателите нема да го видат ова на вашиот профил.',
    customPeriod: 'Прилагоден период...',
    from: 'Од',
    to: 'До',
    selectStart: 'Изберете датум за почеток',
    selectEnd: 'Изберете датум на завршување',
    total: 'Вкупно',
    pendingRequest: 'Барања што чекаат',
    invalid: 'неважечки',
    today: 'Денес',
    months: 'Месеци',
    weeks: 'Недели',
    setAvailability: 'Поставете достапност',
    fansWillOnly:
      'Фановите ќе можат да резервираат само еден-на-еден во рамките на достапните рамки',
    period: 'Период',
    dayOfTheWeek: 'Ден од неделата',
    daily: 'Дневно',
    thisWeek: 'Оваа недела',
    thisMonth: 'Овој месец',
    availableTime: 'Достапно време',
    time: 'Време',
    timeBetween: 'Време помеѓу поврзувањата',
    breakDuration: 'Времетраење на паузата',
    setAvailableTime: 'Поставете го достапното време од',
    chooseATime: 'Изберете време во текот на денот кога сакате да добивате барања за еден-на-еден',
    weekDays: 'Работни денови',
    weekends: 'Викенди',
    oneOnOneConnect: 'Поврзете еден-на-еден',
    save: 'Зачувај',
    search: 'Пребарувајте',
    subscriptions: 'Претплати',
    emailNotifications: 'Известувања по е-пошта',
    languageAndCurrency: 'Јазик и валута',
    theme: 'Тема',
    billing: 'Наплата',
    accessBilling: 'Пристапете до информациите за наплата',
    logOut: 'Одјавете се',
    countryCode: 'Код на државата',
    selectCountry: 'Изберете држава',
    passwordChangeSuccessful: 'Успешно ја ажуриравте лозинката.',
    confirmNewPassword: 'Потврди нова лозинка',
    forgotPassword: 'Ја заборави лозинката?',
    enableEmailNotifications: 'Овозможете известувања по е-пошта',
    newComments: 'Нови коментари',
    newTags: 'нови ознаки',
    newSubscriptions: 'Нови претплати',
    newFriends: 'Нови пријатели',
    friendRequests: 'Барања за пријатели',
    notificationForLikes: 'Известување за „Ми се допаѓа“',
    newMessages: 'Нови пораки',
    photosNotifications: 'Известувања за фотографии',
    language: 'Јазик',
    currency: 'Валута',
    anyone: 'Било кој',
    community: 'Заедница',
    friendsOnly: 'Само пријатели',
    noOne: 'Никој',
    onlyAvailableViaApp: 'Достапно само преку мобилна апликација',
    darkMode: 'Темен режим',
    contentPrivacySettings: 'Поставки за приватност на содржината',
    setAvailableTimeTo: 'Поставете го достапното време на',
    chooseATimeTo: 'Изберете време во текот на денот кога сакате да добивате барања еден-на-еден',
    removeAccount: 'Отстранете ја сметката',
    accountPrivacy: 'Сметка'
  },
  scheduleConnect: {
    '15minutesCall': '15 минути повик',
    thereIsNo: 'Нема достапност за овој датум.',
    selectTime: 'Изберете време',
    bookOneOnOne: 'Резервирајте еден-на-еден',
    youAlreadyHave: 'Веќе имате врска со овој спортист.',
    scheduleAlreadyExist: 'Распоредот веќе постои',
    ad: 'Реклама',
    nextAvailableSlot: 'Следна достапна рамка',
    noScheduleFound: 'Не е пронајден распоред',
    thisUserHasnt:
      'Овој корисник сè уште не го поставил својот распоред. Ве молиме вратете се подоцна.',
    schedule: 'Распоред',
    today: 'Денес',
    tomorrow: 'Утре',
    weeks: 'Недели',
    seeCalendar: 'Видете го календарот',
    dateAndTime: 'Датум и време',
    edit: 'Уредете',
    total: 'Вкупно:',
    asPerTheTerms:
      'Според одредбите и условите, прифаќам да ми се наплати износот наведен погоре по потврдата од спортистот',
    sendRequest: 'Испратете го барањето',
    oneOnOneRequest: 'Барањето еден-на-еден е испратено',
    afterTheAthleteAccepts:
      'Откако спортистот ќе го прифати вашето барање, ќе го добиете известувањето и ќе го видите претстојното еден-на-еден на контролната табла.',
    goToDashboard: 'Одете на контролната таблата',
    bookOtherOneOnOne: 'Резервирајте други еден-на-еден',
    proceed: 'Продолжете',
    searcAthletes: 'Пребарувајте спортисти',
    notVerified: 'Овој профил не е потврден спортист.',
    bookOneOnOneTeam: 'Booking a Face2Face? Please select your favorite athlete. Thank you!',
    noBooked: 'Сè уште немате резервирано еден-на-еден',
    bookedYet: 'Дали сте резервирале еден-на-еден?',
    selectDay: 'Изберете ден',
    nextOneOnOnes: 'Следни еден-на-еден',
    noResults:
      'Сите наши спортисти имаат преполн распоред. Достапноста се отвора редовно, затоа ве молиме вратете се подоцна.'
  },
  connectsDashboard: {
    byFan: 'ОД ОБОЖАВАТЕЛ',
    byAthlete: 'ОД СПОРТИСТ',
    pending: 'Oбработка',
    confirmed: 'Потврдено',
    rejected: 'Одбиено',
    timeBooked: 'Резервирано време',
    refuseOneOnOneConnect: 'Одбијте ги сите поврзувања еден-на-еден',
    refuseAll: 'Одбијте ги сите',
    oneOnOneConnect: 'Поврзете еден-на-еден',
    bookAgain: 'Резервирајте повторно'
  },
  dashboard: {
    monthlyTarget: 'Месечна цел',
    setMonthlyRevenueTarget: 'Сè уште не сте ја поставиле целта за месечни приходи.',
    useAthleteRefferalCodes:
      'Користете ги кодовите за препорака на спортисти за да го зголемите тимот',
    setupRateAndAvailability: 'Стапка на поставување и достапност за добивање барања еден-на-еден.',
    shoutouts: 'Пофалби',
    vipConnect: 'VIP Поврзување',
    week: 'Недела',
    month: 'Месец',
    year: 'Година',
    all: 'Сите',
    custom: 'Прилагодено...',
    total: 'Вкупно',
    dashboard: 'Контролна табла',
    referrals: 'Препораки',
    income: 'Приходи',
    users: 'Корисници',
    subscribed: 'Претплатени',
    progress: 'Напредок',
    followers: 'Следбеници',
    advertising: 'Рекламирање',
    views: 'Прегледи',
    number: 'Број',
    athleteEmail: 'Е-пошта на спортистот',
    meetings: 'Состаноци',
    itemsSold: 'Продадени артикли',
    store: 'Продавница',
    editMonthlyTarget: 'Уредете месечна цел',
    inviteToGrow: 'Напишете е-пошта за да испратите покана за развој на тимот.',
    inviteAthletes: 'Поканете спортисти',
    follower: 'Следбеници'
  },
  editProfile: {
    sport: 'Спорт',
    selectSuport: 'Изберете Спорт',
    favoriteTeam: 'Омилен тим',
    selectTeam: 'Изберете Тим',
    favoritePlayer: 'Омилен играч',
    selectPlayer: 'Изберете Player',
    addMoreSport: 'Додадете повеќе спортови',
    editProfile: 'Уредете го профилот',
    dateOfBirth: 'Дата на раѓање',
    bio: 'Био',
    mySport: 'Мојот спорт',
    mySports: 'Моите спортови',
    position: 'Позиција',
    selectPosition: 'Изберете Позиција',
    level: 'Ниво',
    selectLevel: 'Изберете Ниво',
    personalInformation: 'Лични податоци',
    myGender: 'Мојот пол',
    female: 'Женско',
    male: 'Машко',
    other: 'Друго',
    imFrom: 'Јас сум од',
    yourPhoneNumber: 'Вашиот телефонски број'
  },
  profile: {
    wantToConnect: 'Сакате да стапите во контакт лице в лице?',
    favoriteSports: 'Омилени спортови',
    favoriteAthlete: 'Омилен спортист',
    referAndReward: 'Добијте награда преку препорака на спортист',
    invitePeople: 'Поканете луѓе',
    earnMoreReferralFees: 'Заработете повеќе такси за препораки со поканување спортисти околу вас',
    inviteAthleteFan: 'Поканете спортисти и навивачи',
    typeEmailToInvite: 'Напишете е-пошта за да испратите покана за развој на тимот.',
    athleteEmail: 'Е-пошта на спортистот',
    doesntExists: 'Овој корисник не постои.',
    latestShoutouts: 'Најнови пофалби',
    mySports: 'Моите спортови',
    myEquipment: 'Мојата опрема',
    relatedProducts: 'Слични производи',
    bidForEquipment: 'Понуда за мојата опрема',
    goToAppSettings: 'Одете во поставките на апликацијата',
    recentShoutouts: 'Неодамнешни пофалби',
    recentUpdates: 'Неодамнешни ажурирања',
    trendingPosts: 'Актуелни Објави',
    following: 'Следите',
    userNotFound: 'Корисникот @ {{username}} не е пронајден',
    searchFriendsAndFollowers: 'Пребарувајте пријатели и следбеници',
    noUpdatesYet: '{{name}} сè уште нема ажурирања',
    noPostsYet: '{{name}} сè уште не објавил',
    followToKnowFirst:
      'Следете го {{name}} за да бидете првиот што знае за ажурирања како подкасти или пренос во живо.',
    encourage: 'Слободно испратете им пофалба за да ги охрабрите.',
    threeMonthsAccess: 'Имате три месеци неограничен пристап до затворени врати',
    enjoyFreeAccess: 'Уживајте во ексклузивната содржина од спортистите.',
    repostHeader:
      '<strong> {{owner}} <\/strong> сподели <strong> {{originalOwner}} <\/strong> објавата',
    nowFollowing: 'Сега го следите {{name}}',
    sureToRemove:
      'Дали сте сигурни дека сакате да ја отстраните вашата сметка? Оваа постапка е неповратна.',
    getUnlimited: 'Добијте неограничена содржина',
    getUnlimitedDesc:
      'Претплатете се на вашиот омилен спортист за да добивате ексклузивни содржини.',
    verifiedAthlete: 'Верифиџиран спортист'
  },
  notifications: {
    notifications: 'Известувања',
    comingUpConnect: 'Доаѓа еден-на-еден со {{sender}} за пет минути',
    connectRequest: 'Барање еден-на-еден од {{sender}}',
    connectStatus: '{{status}} еден-на-еден со {{sender}}',
    connectStarting:
      'Време е да ги започнете вашите резервирани 15 минути еден-на-еден со {{sender}}',
    commentedToPost: 'коментираше на вашата објава',
    commentedToSportChat: '<strong>{{sender}}</strong> \ncommented on your sport chat',
    reactedToPost: 'реагираше на вашата објава',
    reactedToShoutout: 'реагираше на вашата пофалба',
    amountReactedToPost: '{{amount}} луѓе реагираа на вашата објава',
    aNewShoutout: 'Имате нова пофалба',
    newShoutouts: 'Имате {{amount}} нови пофалби',
    shoutoutReaction: '{{sender}} реагираше на вашата пофалба',
    startedFollowing: '{{sender}} почна да ве следи',
    amountStartedFollowing: '{{amount}} корисници почнаа да ве следат',
    newSub: 'Имате нов претплатник',
    newSubs: 'Имате {{amount}} нови претплатници',
    newRequests: '{{amount}} нови барања еден-на-еден',
    newFollower: 'почна да ве следи',
    taggedInPost: '<strong> {{sender}} <\/strong>\n ве означи во нивната објава',
    mentionedInPost: '<strong> {{sender}} <\/strong>\n ве спомна во нивната објава',
    commentTagged: '<strong> {{sender}} <\/strong>\n ве означи во нивниот коментар',
    p4pMonetizingYourBrand: 'P4P го монетизира твојот бренд!',
    fanRequestingShoutout: 'Еден фан бара поддршка.',
    view: 'Погледни',
    congratulations: 'Честитки!',
    yourFavoriteAthleteCompletedYourRequest: 'Вашиот омилен спортист ја комплетираше поддршката.',
    sorryFavoriteAthleteCurrentlyUnavailable:
      'Извини, твојот омилен спортист не е достапен во моментов. Те замолуваме обиди се повторно подоцна или избери друг играч.',
    sportChatCommentTagged: '<strong>{{sender}}</strong> \ntagged you in their sport chat comment',
    startedSubscribing: '<strong> {{sender}} <\/strong>\n сега ви е претплатен'
  },
  repost: {
    tagFriends: 'Означете пријатели',
    repost: 'Повторно објавување',
    create: 'Креирајте',
    yourComment: 'Вашиот коментар',
    shareWith: 'Споделете со',
    everyone: 'Сите',
    OnlyPeopleIFollowBack: 'Само луѓе што ги следам'
  },
  onBoarding: {
    everybody: 'СИТЕ',
    plays: 'ИГРАТ',
    better: 'ПОДОБРО',
    together: 'ЗАЕДНО.',
    favoriteSports: 'Омилени спортови',
    chooseSports:
      'Изберете спорт и изберете го вашиот омилен тим на спортисти за да ве информираме.',
    selectSport: 'Изберете спорт',
    sport: 'Спорт',
    favoriteTeam: 'Омилен тим',
    selectTeam: 'Изберете Тим',
    favoritePlayer: 'Омилен играч',
    selectPlayer: 'Изберете играч',
    addMoreSport: 'Додадете повеќе спортови',
    getStarted: 'Почнете',
    youreAlmostThere: 'Уште малку',
    tellUsAboutYourself: 'Кажете ни за себе за да ги добиете најрелевантните објави и ажурирања.',
    imFrom: 'јас сум од',
    yourPhoneNumber: 'Вашиот телефонски број',
    dateOfBirth: 'Дата на раѓање',
    monthlyRevenueTarget: 'Месечна цел на приходи',
    pleaseShareYour:
      'Ве молиме споделете ги вашите месечни очекувања за приходи. Фановите нема да го видат ова на вашиот профил.',
    next: 'Следно',
    skipThisStep: 'Прескокнете го овој чекор',
    yourSports: 'Вашите спортови',
    chooseASport: 'Изберете спорт и изберете ја вашата позиција.',
    mySport: 'Мојот спорт',
    position: 'Позиција',
    selectPosition: 'Изберете Позиција',
    addSecondarySport: 'Додадете секундарен спорт',
    chooseSportsYou: 'Изберете спорт за кој сте заинтересирани.',
    skipAndGet: 'Прескокнете и започнете',
    connectDirectlyWith: 'Поврзете се директно со вашите омилени спортисти и други фанови.',
    monetizeYourBrand: 'Заработете од вашиот бренд создавајќи уникатен свет со вашите обожаватели.',
    chooseAUsername: 'Избери корисничко име',
    referralCodeOptional: 'Код за препорака (опционално)',
    backTo: 'Назад кон',
    logIn: 'Логирајте се',
    imAFan: 'Јас сум обожавател',
    imAnAthlete: 'Јас сум спортист',
    createAnAccount: 'Направете профил',
    searchTeams: 'Пребарувајте тимови'
  },
  shoutout: {
    comingSoon: 'Пофалбата доаѓа наскоро',
    comingSoonDesc:
      'Комуницирајте со познати спортисти ширум светот, испраќајќи мотивирачки и славенички пофалби.',
    success: 'Пофалбата е успешно испратена.',
    selectTeamOrAthete: 'Избери Тим или Спортист',
    teamOrAthlete: 'Тим/Спортист',
    writeShoutout: 'Напиши признание',
    createMatchDayShoutout: 'Напиши признание за натпреварот',
    matchDayShoutouts: 'Признанија за натпреварот',
    shoutoutsFromAthletes: 'Од спортисти',
    shoutoutsFromFans: 'Од фанови'
  },
  shop: {
    comingSoon: 'Продавницата доаѓа наскоро',
    comingSoonDesc:
      'Стока од вашите омилени познати спортисти, билети за настани, ексклузивни понуди и повеќе ќе бидат достапни преку нашата продавница. Наскоро ќе ве известиме за отворањето.'
  },
  header: {
    logOutConfirmation:
      'Сакате да се одјавите од вашиот профил? Можете да се најавите подоцна користејќи ги вашите податоци.',
    upgradePlan: 'Надградете го планот'
  },
  post: {
    timestampYear: 'y',
    timestampMonth: 'м',
    timestampWeek: 'w',
    timestampDays: 'г',
    timestampHour: 'ч',
    timestampSecond: 'с',
    deletePost: 'Избриши ја објавата',
    editPost: 'Уредете ја објавата',
    reportPost: 'Пријавете ја објавата',
    areYouSure: 'Дали сте сигурни дека сакате да ја избришете вашата објава?',
    reportingSoon: 'Известувањето сè уште не е достапно. Ве молиме вратете се подоцна.',
    beingProcessed: 'Ова видео се обработува, вратете се подоцна.'
  },
  billing: {
    billing: 'Наплата',
    settings: 'Поставки',
    history: 'Историја',
    billingInformation: 'Информации за наплата',
    paymentMethod: 'Метод на плаќање',
    addPaymentMethod: 'Додајте начин на плаќање',
    youNeedToAddMethod: 'Треба да додадете начин на плаќање',
    forYourPurches:
      'Ќе бидете пренасочени на нашата веб-апликација за да го додадете вашиот начин на плаќање.',
    goToWebApp: 'Одете до веб-апликацијата',
    exp: 'Датум на истекување',
    removingCard: 'Оваа картичка ќе биде отстранета',
    sureToRemove: 'Дали сте сигурни дека сакате да го отстраните **** {{last4}} ?',
    noPaymentsYet: 'Сè уште нема плаќања',
    processedPaymentsHere: 'Овде ќе ја видите листата на обработени плаќања.',
    shoutoutTo: 'Пофали го {{name}}',
    connectWith: 'Поврзете се еден-на-еден со {{name}}',
    connectRefused: 'Поврзувањето еден-на-еден е одбиено од {{name}}',
    connectCanceledBy: 'Поврзувањето еден-на-еден е откажано од {{name}}',
    termsAndConditions:
      'Според условите и условите, прифаќам да ми се наплати износот наведен погоре при потврдата за p4p',
    swipeRightToPurchase: 'Повлечете надесно за да купите',
    subscription: 'Претплатете се на {{name}}',
    purchase: 'Купи'
  },
  revenueTarget: {
    none: 'Ништо',
    oneThousand: 'До 1000 долари',
    fiveThousand: 'До 5.000 долари',
    tenThousand: 'До 10.000 долари',
    hundredThousand: 'До 100.000 долари',
    oneMillion: 'До 1.000.000 долари',
    moreThanMillion: 'Повеќе од 1.000.000 долари'
  },
  forgotPassword: {
    recoveryEmailSent: 'Испратена е-пошта за враќање',
    checkYourInbox:
      'Проверете го вашето сандаче (и папките за спам) за да ги најдете и следете упатствата за ресетирање на лозинката.',
    backToLogin: 'Назад на Најавете се',
    passwordReset: 'Ресетирање на лозинката',
    enterEmail:
      'Внесете ја е-поштата поврзана со вашата сметка и ние ќе ви ги испратиме упатствата за враќање на лозинката.',
    sendRecovery: 'Испратете е-пошта за враќање на лозинката',
    checkEmail: 'Проверете ја вашата адреса за е-пошта',
    noAccount: 'Нема поврзана сметка',
    anotherAddress: 'Ве молиме обидете се со друга адреса.',
    tryAnother: 'Обидете се со друга е-пошта',
    createNewPassword: 'Направете нова лозинка',
    doesntMatch: 'Не се совпаѓаат',
    newPassword: 'Нова лозинка',
    resetPassword: 'Ресетирање на Лозинката',
    passwordRule1: 'Новата лозинка треба да се разликува од претходната.',
    passwordRule2: 'Најмалку 8 знаци - колку повеќе знаци, толку подобро.',
    passwordRule3: 'Мешавина на големи и мали букви.',
    passwordRule4: 'Мешавина на букви и бројки.',
    passwordRule5: 'Барем еден посебен знак, на пр., ! @ # ?'
  },
  getTheApp: {
    header: 'Преземете ја апликацијата playaz4playaz за вашиот паметен телефон',
    setupAccount:
      'Преземете ја апликацијата playaz4playaz за вашиот паметен телефон за да ја поставите вашата сметка.'
  },
  share: {
    repost: 'Споделете',
    copyLink: 'Копирај го линкот',
    viaMessage: 'Споделете преку пораката',
    toFb: 'Споделете на Фејсбук',
    toInst: 'Споделете на Инстаграм',
    toTwit: 'Споделете на Твитер',
    toWhapp: 'Споделете на WhatsApp',
    toTelg: 'Споделете на Telegram',
    viaEmail: 'Споделете преку е-пошта'
  },
  verification: {
    verifyProfile: 'Потврдете го вашиот профил',
    verifyProfile2: 'Потврдете го профилот',
    accountNeedsVerification:
      'Треба да ја потврдите вашата сметка. Направете селфи со личната карта до лицето. Тоа може да го направите подоцна од Профилот.',
    needVerification: 'Треба да ја потврдите сметката за да се придружите на еден-на-еден.',
    yourProfileVerified: 'Вашиот профил е потврден',
    verificationRequested: 'Побарана е потврда',
    beingVerified:
      'Профилот се потврдува во рок од 24 часа. Штом заврши, можете да се вклучите во еден-на-еден откако ќе се обработи плаќањето.',
    profileVerifiedDescription:
      'Ви благодариме што ја завршивте потврдата. Сега можете да се вклучите во закажаниот еден-на-еден.'
  },
  events: {
    shoutouts: 'Извици',
    livescore: 'Резултати во живо',
    pictures: 'Слики',
    stats: 'Статистики',
    noShoutouts: 'Сè уште нема пофалби на овој настан',
    addShoutout: 'Биди првиот што ќе испрати пофалба!'
  },
  games: {
    ht: 'Полувреме',
    ft: 'Конечно време',
    matchday: 'Натпревар {{round}}',
    roundOf16: '16-та рунда',
    quarterFinal: 'Четврт финале',
    semiFinal: 'Полуфинале',
    playOff: 'Плеј оф',
    playoffFinal: 'Финале на плејофот',
    final: 'Финале',
    preSeason: 'Пред сезоната',
    playOffSemiFinal: 'Полуфинале на плејофот',
    wantToShoutout: 'Сакате да пофалите некого?'
  },
  permissions: {
    permissionsBlocked: 'Дозволите се блокирани',
    goToYourSettings: 'Одете во вашите поставки и овозможете {{permission}}',
    openSettings: 'Отворете ги поставките',
    camera: 'Камера',
    microphone: 'Микрофон',
    gallery: 'Галерија'
  },
  store: {
    suggestedItems: 'Предложени предмети',
    liked: 'Допаднати',
    merchandise: 'Стока',
    tickets: 'Билети',
    fromSubscribed: 'Од претплатени спортисти',
    productDetails: 'Детали за производот',
    selectSize: 'Изберете големина',
    selectStock: 'Изберете тип',
    seeSizeGuide: 'Погледнете го водичот за големина',
    currentBid: 'Тековна понуда',
    placeBid: 'Поставете понуда',
    likedProducts: 'Допаднати производи',
    noLiked: 'Сè уште нема омилени производи',
    addToCart: 'Додади го во кошничка',
    cart: 'Количка',
    totalCost: 'Вкупните трошоци:',
    checkout: 'Исплата',
    orderSuccessful: 'Нарачката е успешна',
    size: 'Големина',
    price: 'Цена',
    proceedToPayment: 'Продолжете со плаќање',
    sizeWithDesc: '{{size}} големина',
    clearAll: 'Исчисти'
  },
  goLive: {
    onlineCount: '{{onlineCount}} претплатници онлајн',
    onlineCountFan: '{{onlineCount}} следбеници на интернет',
    watchingCount: '{{watchingCount}} гледа',
    youAreLive: 'Вие сте во живо!',
    streamIsFinished: 'Преносот е завршен.',
    live: 'ВО ЖИВО',
    end: 'Крај',
    comment: 'Коментар',
    tapForGoLive: 'Допрете за да одете во живо'
  },
  subscribe: {
    monthly: 'Месечно',
    annual: 'Годишен',
    off: '{{amount}} % ПОПУСТ',
    upToOff: 'ДО {{amount}} % ПОПУСТ',
    athletesAndTeams: 'Спортисти и тимови',
    subscribeFor: 'Претплатете се за <strong> {{amount}} <\/strong> \/месец',
    subscriptionSummary: 'Резиме на претплата',
    introductoryOffer: 'Воведна понуда',
    annualDiscount: 'Платете 10 месеци за 12 со Годишен попуст',
    noResults: 'Не се најдени резултати со наведените критериумите',
    teamFan: 'Навивач на {{team}} ?',
    subscribeForTeam:
      'Претплатете се за сите тимски спортисти од <strong> {{amount}} <\/strong> \/месец',
    seeAllAthletes: 'Видете ги сите {{number}} спортисти',
    subscribeModalTitle: 'Претплатете се на вашите омилени спортисти и тимови',
    subscribeModalDesc:
      'Уживајте во ексклузивната содржина од спортистите и тимовите. Претплатете се на тимовите кои добиваат целосен пристап на играчите почнувајќи од 5,99 долари.',
    athletesToSubscribe: 'Спортисти да се претплатите',
    numberAthletes: '{{amount}} спортисти',
    cancelSubscription: 'Откажете ја претплатата',
    daysLeftInPeriod: 'Преостануваат {{amount}} дена во тековниот период',
    sureToCancel: 'Дали сте сигурни дека сакате да ја откажете претплатата?',
    bundleSquad: '{{name}} одред',
    remindMeLater: 'Потсети ме подоцна'
  },
  americanFootball: {
    quarterback: 'Одбранбен играч',
    runningBack: 'Трчање назад',
    wideReceiver: 'Широк ресивер',
    tightEnd: 'Тесен крај',
    leftGuard: 'Лева гарда',
    rightGuard: 'Десна стража',
    center: 'Центарот',
    leftTackle: 'Лево справување',
    rightTackle: 'Правилно справување',
    noseTackle: 'Справување со носот',
    defensiveTackles: 'Одбранбени справувања',
    offensiveTackles: 'Навредливи справувања',
    offensiveLineman: 'Офанзивен човек',
    middleLineBacker: 'Поддржувач на средната линија',
    outsideLineBacker: 'Поддржувач на надворешната линија',
    defensiveBack: 'Одбранбен бек',
    flanker: 'Фланкер',
    splitEnd: 'Сплит крај',
    kicker: 'Кикер',
    punter: 'Пантер',
    cornerback: 'Заден агол',
    safety: 'Безбедност',
    defensiveEnd: 'Одбранбен крај',
    runningBackHalfback: 'Трчање назад (полубек)',
    runningBackFullback: 'Враќање назад (повратен удар)'
  },
  baseball: {
    centerFielder: 'Центар Филдер',
    pitcher: 'Фрлач',
    catcher: 'Фаќач',
    baseman: 'Бејсмен',
    shortstop: 'Краток стоп',
    leftFielder: 'Левиот теренец',
    rightFielder: 'Десен Филдер',
    firstBaseman: 'Првиот Бејсмен',
    secondBaseman: 'Вториот Бејсмен',
    thirdBaseman: 'Трет Бејмен',
    designatedHitter: 'Назначен напаѓач'
  },
  basketball: {
    pointGuard: 'Точка стража',
    shootingGuard: 'Стрелачка',
    smallForward: 'Мал Напред',
    powerForward: 'Центар напред',
    center: 'Центарот',
    comboGuard: 'Комбо гарда',
    wingGuard: 'Стража на крилото',
    pointForward: 'Посочете напред',
    comboForward: 'Комбо напред'
  },
  cricket: {
    captain: 'Капетан',
    wicketkeeper: 'Wicketkeeper',
    slip: 'Лизгање',
    gully: 'Гали',
    point: 'Точка',
    cover: 'Покријте',
    thirdMan: 'Трет човек',
    fineLeg: 'Фина нога',
    midWicket: 'Играчот од средниот ред Викет',
    midOff: 'Исклучен играч од средниот ред',
    squareLeg: 'Квадратна нога'
  },
  soccer: {
    goalkeeper: 'Голман',
    striker: 'Напаѓач',
    centerbackStopper: 'Централен бек (стопер)',
    centerbackSweeper: 'Централен бек (чистач)',
    centerbackQuarterBack: 'Централен бек (четврт-бек)',
    rightFullback: 'Десен бек',
    leftFullback: 'Лев бек',
    centerForward: 'Центар напред',
    wingers: 'Крилните играчи',
    leftMid: 'Лев играч од средниот ред',
    wideMid: 'Широк играч од средниот ред',
    rightMid: 'Десен среден бек',
    centerMid: 'Централен играч од средниот ред',
    attackingMid: 'Офанзивен играч од средниот ред',
    defensiveMid: 'Дефанзивен играч за врска',
    defensiveMidBallWinner: 'Дефанзивен играч за врска (победник на топката)',
    defensiveMidDeepLyingPlaymaker: 'Дефанзивен играч за врска (длабоко лежи плејмејкер)',
    boxToBoxMid: 'Среден ред од кутија до кутија',
    wingback: 'Крилен играч\/Крилен бек',
    false9: 'Неточно 9',
    raumdeuter: 'Раумдојтер',
    forward: 'Напред'
  },
  tennis: {
    oneUp: 'Еден-нагоре',
    oneBack: 'Еден Назад'
  },
  handball: {
    goalkeeper: 'Голман',
    leftBack: 'Лев бек',
    centerBack: 'Централен бек\/Центар',
    rightBack: 'Десен бек',
    leftWinger: 'Лево крило',
    centerForward: 'Центар напред \/ Пивот \/ Кружен тркач',
    rightWinger: 'Десно крило',
    farRight: 'Далечна десница',
    halfRight: 'Полудесно',
    backCenter: 'Заден центар',
    frontCenter: 'Преден центар'
  },
  iceHockey: {
    leftDefenseman: 'Левиот бранител',
    goaltender: 'Голман',
    rightDefenseman: 'Десен бранител',
    leftWinger: 'Лево крило',
    center: 'Центарот',
    rightWinger: 'Десно крило'
  },
  lacrosse: {
    attackmen: 'Напаѓачи',
    mid: 'Играч од средниот ред',
    defensemen: 'Бранители',
    goalkeeper: 'Голман'
  },
  polo: {
    lowWingLeftWing: 'Ниско крило\/лево крило',
    lowWingRightWing: 'Ниско крило\/десно крило',
    centerHoleSet: 'Комплет центар\/дупка',
    topWingLeftFlat: 'Горно крило\/лево рамен',
    topWingRightFlat: 'Горно крило\/десно рамен',
    point: 'Точка',
    cornerPost: 'Катче\/Пост',
    middleDefense: 'Среден\/одбрана',
    topDefense: 'Врвна одбрана'
  },
  rowing: {
    coxswain: 'Коксвејн',
    rower: 'Веслач'
  },
  softball: {
    pitcher: 'Фрлач',
    catcher: 'Фаќач',
    firstBaseman: 'Првиот Бејсмен',
    secondBaseman: 'Вториот Бејсмен',
    shortstop: 'Краток стоп',
    thirdBaseman: 'Трет Бејмен',
    leftFielder: 'Лев Филдер',
    centerFielder: 'Центар Филдер',
    rightFielder: 'Десен Филдер'
  },
  rugby: {
    looseheadProp: 'Реквизит со лабава глава',
    hooker: 'Хукер',
    tightheadProp: 'Проп',
    lock2ndRow: 'Заклучување\/2-ри ред',
    blindSideFlanker: 'Фланкер од слепа страна',
    openSideFlanker: 'Фланкер од отворена страна',
    number8: 'Број 8',
    scrumHalf: 'Scrum Половина',
    flyHalf: 'Летај половина',
    leftWing: 'Лево крило',
    insideCenter: 'Внатрешем Центар',
    outsideCenter: 'Надворешен Центар',
    rightWing: 'Десно крило',
    fullback: 'Фолбек'
  },
  volleyball: {
    setter: 'Сетер',
    outsideHitter: 'Надвор хитер',
    middleBlocker: 'Среден блокатор',
    libero: 'Либеро',
    oppositeHitter: 'Спроти хитер'
  },
  stories: {
    subscribeTo: 'Претплатете се за да добиете пристап до повеќе приказни од {{name}}'
  },
  reports: {
    descriptionPlaceholder: 'Опишете ја вашата причина...',
    reportingPost: 'Пријавување на објавата на {{name}}',
    reportingShoutout: 'Пријавување на пофалбата на {{name}}',
    reportingStory: 'Пријавување на приказната на {{name}}',
    report: 'Извештај'
  },
  error: {
    noNetwork: 'Нема конекција',
    somethingWentWrong: 'Нешто тргна наопаку!',
    pleaseTryAgainLater: 'Обидете се повторно подоцна.'
  },
  requestShoutout: {
    discardChanges: 'Поништи ги промените?',
    selectAthlete: 'Избери спортист',
    newRequest: 'Ново барање',
    requestAShoutout: 'Побарај поддршка',
    itsMine: 'Мое е',
    forSomeoneElse: 'За некој друг е',
    whatIsYourName: 'Кое е твоето име?',
    introduction: 'Претстави се',
    selectOcassion: 'Избери пригода/причина',
    birthday: 'Роденден',
    anniversary: 'Годишнина',
    motivational: 'Мотивациско',
    mentorship: 'Менторство',
    gender: 'Пол',
    addInstruction: 'Додај инструкции (што би сакале тие да кажат)',
    deliveryInfo: 'Достави информација',
    standard: 'Стандардно',
    videoDelivered: 'Видеото ќе биде испратено за {{day}} дена',
    requestSent: 'Твоето барање е испратено',
    requestConfirmation:
      'Тукушто го испративме твоето барање до {{athlete}}. Времето потребно за комплетирање е {{day}} дена, но оптимистични сме дека би било завршено и многу поскоро.',
    whoThisFor: 'Од кого е ова?',
    standard: 'Стандардно ({{price}})',
    bookNow: 'Резервирај сега!',
    backToShoutout: 'Назад кон поддршките',
    maximum18Chars: 'Максимум 18 карактери',
    maximum200Chars: 'Максимум 200 карактери',
    youCanAdd18Chars: 'Може да внесете до 18 карактери',
    youCanAdd200Chars: 'Може да внесете до 200 карактери'
  },
  yourRequests: {
    view: 'Погледни',
    yourRequests: 'Твоите барања',
    myShoutoutRequests: 'Моите барања за поддршка',
    shoutoutRequestsFromFans: 'Shoutout Requests from Fans',
    face2faceRequests: 'Лице в лице барања',
    all: 'Сите',
    pending: 'Oбработка',
    completed: 'Завршени',
    unfulfilled: 'Неисполнети',
    fromAthletes: 'Од спортисти',
    fromFans: 'Од фанови',
    dayLeft: '{{dayLeft}} Ден преостанат',
    daysLeft: '{{dayLeft}} Денови преостанати',
    fulfilledOn: 'Комплетиран/и на {{date}}',
    unfulfilledOn: 'Некомплетиран/и на {{date}}',
    decline: 'Одбиј',
    startRecording: 'Започни со снимање',
    record: 'Снимај',
    tapForRecording: 'Притисни за снимање',
    send: 'Испрати',
    completeTheRequest: 'Заврши го барањето',
    discardChanges: 'Поништи ги промените?',
    confirm: 'Потврди',
    cancel: 'Прекини',
    awesome: 'Прекрасно',
    shoutoutSuccessfullySent: 'Твојата поддршка беше успешно испратена.',
    declineTheRequest: 'Прекини го барањето',
    busyConsiderToProfit:
      'Разбираме дека си зафатен, те замолуваме да ја разгледаш можноста да заработиш од твојот бренд на следното барање.'
  },
  shoutoutsVideoGallery: {
    fromMe: 'Од мене',
    fromFellowAthletes: 'Од колегите спортисти',
    for: 'Од {{name}}'
  },
  letsChatSports: {
    startChat: 'Start Chat',
    writeTopic: 'Write a topic'
  }
};
